import { ReactNode, useMemo } from 'react';

import { quickContext } from 'utils/react';

/**
 * This could easily be inside the 'Provider' component file
 *
 * But Vite gives a warning on bad hydration if we export the useTab on the same file as the component
 */

export type TabType = 'underline' | 'boxed' | 'highlighted';

export interface TabProviderProps {
  defaultValue?: string;
  value?: string;
  onTabChange?: (tab: string) => void;

  fullWidth?: boolean;
  type?: TabType;
  className?: string;

  contentFlow?: 'top-to-bottom' | 'left-to-right';

  children: ReactNode;
}

type TabContext = Required<
  Pick<TabProviderProps, 'value' | 'onTabChange' | 'contentFlow' | 'fullWidth' | 'type'>
>;

export const { TabProvider, useTab } = quickContext(
  'tab',
  ({ fullWidth, onTabChange, type, value, contentFlow }: TabContext) => {
    return {
      data: useMemo(
        () => ({
          fullWidth,
          contentFlow,
          onTabChange,
          type,
          value,
        }),
        [fullWidth, onTabChange, type, value, contentFlow],
      ),
    };
  },
);
